
(function () {

    'use strict';
    angular.module('app')
        .service('dashboardService', ['$http', function ($http) {
            this.GetClients = function () {
                return $http.get('api/dashboard/getclients')
                    .then(function (response) {
                        return response.data;
                    },
                        function () {
                            throw ('Restricted Logins Failure');
                        });
            };
            this.GetClientRedirectUrl = function (clientId, linkId) {
                return $http.get('api/dashboard/getclientredirecturl',
                    { params: { clientId: clientId, linkId: linkId } })
                    .then(function (response) {
                        return response.data;
                    },
                        function () {
                            throw ('URL Retrieval Failure');
                        });
            };
            this.attachAccount = function (username, password, clientId, clientDetailsId) {
                return $http.post('api/dashboard/attachClientUser',
                    { Username: username, Password: password, Type: clientId, ClientDetailsId: clientDetailsId })
                    .then(function (response) {
                        return response.data;
                    },
                        function (response) {
                            throw response;
                        });
            };


            this.removeClientUser = function (id) {
                return $http.delete('api/dashboard/removeClientUser', { params: { id: id } });
            };

            this.defaultClientUser = function (id) {

                return $http.post('api/dashboard/defaultClientUser/' + id)
                    .then(function (response) {
                        return response.data;

                    },
                        function () {
                            throw ('Accounts Attach Failure');
                        });

            };
            this.updateClientAccounts = function (accounts) {

                return $http.put('api/dashboard/updateClientAccounts/', accounts)
                    .then(function (response) {

                        return response.data;

                    },
                        function () {
                            throw ('Accounts update display name failure');
                        });

            };

        }]
            );
})();